const prodConfig = {
    apiEndpoint: "https://api.finspace.app",
    userApiEndpoint: "https://userapi.finspace.app" 
}

export default prodConfig;